import { Accordion, AccordionDetails, AccordionSummary, Grid, Hidden, Tooltip } from '@material-ui/core';
import AuthContext from '@cpg-its/ads.auth.auth-context';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Loader from '@cpg-its/ads.common.loading-circle';
import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';
import ErrorIcon from '@material-ui/icons/Error';
import { buttonStyles } from '../../../../global/constants/theme/styles/components/buttonstyles';
import { Address } from '../../../../global/dto/shared-data-model';
import { ListItem } from '../../../../search/search-model';
import { ErrorStatus, NonStipendiary, Ok, No } from '../../constants/constant-strings';
import { SearchProps } from '../../models/arc-epi-props';
import { Employee } from '../employment/employment-model';
import { getFormattedName } from '../../../../global/helpers/employee-helpers';
import { WysiwygWithReactLink } from '../../../../global/components/wysiwyg-with-react-link';
import { getStatusDisplay } from '../employment/employment-slice';
import { ApiEndpoint } from '../../../../global/constants/api-endpoints';


interface EmployeeItemProps {
	item: ListItem,
	settings: SearchProps,
	onSetEmployee: () => void,
	onRemoveClick: () => void,
}
interface AddressProps {
	address: Address
}

export const EmployeeItemView = (props: EmployeeItemProps) => {

	const casted = props.item as Employee;
	const buttonClasses = buttonStyles();
	const [statusData, setStatusData] = useState(null);
	const { accessToken } = useContext(AuthContext) as any;

	const getStatus = () => {
		if (casted?.employmentType?.toLowerCase() !== NonStipendiary.toLowerCase()) {
			axios.defaults.headers = {
				'Cache-Control': 'no-cache',
				'Expires': '0',
			};
			axios.request({
				url: `${ApiEndpoint.benAdmin}/employees/${casted?.guid}/employments/${casted?.employment_id}/details`,
				headers: {
					'Authorization': `Bearer ${accessToken}`,
					'Content-Type': 'application/json',
					'Accept': '*/*',
				},

			}).then(({ data }) => {
				setStatusData(data);
			}).catch(() => {
				setStatusData({ status_indicator: ErrorStatus });
			});
		}

	};

	useEffect(() => {
		getStatus();
	}, []);


	const SimpleAddressDisplay = (addressProps: AddressProps) => {
		return (
			<div>
				<p>{addressProps.address?.city}, {addressProps.address?.state}</p><p>{addressProps.address?.postal_code} {addressProps.address?.country}</p>
			</div>);
	};

	const FullAddressDisplay = (addressProps: AddressProps) => {
		return (
			<div>
				<p>{addressProps.address?.address1}, {addressProps.address?.address2} {addressProps.address?.address3}</p>
				<p> {addressProps.address?.city}, {addressProps.address?.state} {addressProps.address?.postal_code} {addressProps.address?.country}</p>
			</div>);
	};

	function RenderStatus() {

		if (casted?.employmentType?.toLowerCase() === NonStipendiary.toLowerCase()) {
			return <WysiwygWithReactLink content={props.settings?.statusTextNonStip} />;
		}

		if (!statusData) {
			return <Loader />;
		}

		if (statusData?.status_indicator === Ok) {
			return <Tooltip title={statusData?.tooltips?.status_indicator}><div className='employee-search-item-status employee-search-item-status-complete'><CheckCircleIcon /> <div><p>{getStatusDisplay(statusData?.status_indicator)}</p></div></div></Tooltip>;
		}

		if (statusData?.status_indicator === No) {
			return <div className='employee-search-item-status employee-search-item-status-missing'><ErrorIcon /></div>;
		}

		return <Tooltip title={statusData?.tooltips?.status_indicator}><div className='employee-search-item-status employee-search-item-status-missing'><WarningIcon />&nbsp; <div><p>{getStatusDisplay(statusData?.status_indicator)}</p></div></div></Tooltip>;
	}

	return (
		<>
			<Accordion className='employee-search-item-accordion'>
				<AccordionSummary className='employee-search-item-accordion-summary'
					expandIcon={<ExpandMoreIcon />}
					aria-controls={`content-${casted.id}`}
					id={`header-${casted.id}`}
				>
					<div className='employee-search-table-row'>
						<div className='employee-search-table-row-cell'>
							<Hidden smUp>
								<p className='input-label'>{props.settings?.clientNumberLabel}</p>
							</Hidden>
							<button className={buttonClasses.linkButton} type='button' onClick={props.onSetEmployee}>{casted?.masked_client_number}</button>
						</div>
						<div className='employee-search-table-row-cell'>
							<Hidden smUp>
								<p className='input-label'>{props.settings?.nameLabel}</p>
							</Hidden>
							<div className='employee-search-item-name'>
								{
									/*
									casted?.status === 'Active Clergy' || casted?.status === 'Retired Clergy' ?
										<svg className='clergy-icon' aria-hidden='true' focusable='false'>
											<use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#clergy-icon' />
										</svg>
										: null
									*/
								}
								<div className='employee-search-item-name-text'>  {
									`${getFormattedName(casted)}`
								}</div>
							</div>
						</div>
						<div className='employee-search-table-row-cell'>
							<Hidden smUp>
								<p className='input-label'>{props.settings?.addressLabel}</p>
							</Hidden>
							<SimpleAddressDisplay address={casted?.address} />
						</div>
						<div className='employee-search-table-row-cell'>
							<Hidden smUp>
								<p className='input-label'>{props.settings?.employmentTypeLabel}</p>
							</Hidden>
							{
								casted?.employmentType
							}
						</div>
						<div className='employee-search-table-row-cell'>
							<Hidden smUp>
								<p className='input-label'>{props.settings?.statusLabel}</p>
							</Hidden>
							{RenderStatus()}
						</div>
						<div className='employee-search-table-row-cell'>
							<Hidden smUp>
								<p className='input-label'>{props.settings?.actionLabel}</p>
							</Hidden>
							<button className={`${buttonClasses.linkButton} red-link`} type='button' onClick={props.onRemoveClick}>{props.settings?.removeEmployeeButtonText || 'Remove'}</button>
						</div>
					</div>
				</AccordionSummary>
				<AccordionDetails>
					<Grid container className='employee-search-item-content'>
						<Grid className='employee-search-item-content-column' item xs={12} sm={4}>
							<p className='input-label'>{props.settings?.personalEmailLabel}</p>
							<p>{casted.personal_email_address}</p>
						</Grid>
						<Grid className='employee-search-item-content-column' item xs={12} sm={4}>
							<p className='input-label'>{props.settings?.businessEmailLabel}</p>
							<p>{casted.office_email_address}</p>
						</Grid>
						<Grid className='employee-search-item-content-column' item xs={12} sm={4}>
							<p className='input-label'>{props.settings?.fullAddressLabel}</p>
							<FullAddressDisplay address={casted?.address} />
						</Grid>
						<Grid className='employee-search-item-content-column' item xs={12} sm={4}>
							<p className='input-label'>{props.settings?.ssnLabel}</p>
							<p>{casted.masked_ssn}</p>
						</Grid>
						<Grid className='employee-search-item-content-column' item xs={12} sm={4}>
							<p className='input-label'>{props.settings?.dobLabel}</p>
							<p>{casted.masked_date_of_birth}</p>
						</Grid>
					</Grid>
				</AccordionDetails>
			</Accordion>

		</>
	);

};

